import XLSX from 'xlsx';

export interface SheetData {
    headers: string[];
    items: any[];
}

export function readFile(file: File): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => {
            resolve(e.target?.result as ArrayBuffer);
        };
        reader.onerror = e => {
            reject(e);
        };
        reader.readAsArrayBuffer(file);
    });
}


export async function processDailySalesExcelFile(
    file: File,
    targetSheet: string
): Promise<SheetData | null> {
    try {
        const data = await readFile(file);
        const workbook = XLSX.read(data, { type: "array" });

        const targetSheetName = workbook.SheetNames.find(
            name => name.trim() === targetSheet
        );
        if (!targetSheetName) {
            console.error(`No se encontró la hoja "${targetSheet}"`);
            return null;
        }
        const worksheet = workbook.Sheets[targetSheetName];

        const rawData: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        if (!rawData || rawData.length < 2) {
            console.error(`La hoja "${targetSheet}" no tiene suficientes datos.`);
            return null;
        }

        let headerRowRaw = rawData[0] as any[];
        let headerRow = headerRowRaw.map(cell => {
            if (typeof cell === "string") return cell.trim();
            if (cell != null) return String(cell).trim();
            return "";
        });

        if (
            headerRow.length < 4 ||
            headerRow[0].toUpperCase() !== "DEALER" ||
            headerRow[1].toUpperCase() !== "ITEMS"
        ) {
            console.error(
                `El encabezado de la hoja "${targetSheet}" debe iniciar con "DEALER" y "ITEMS".`
            );
            return null;
        }

        const lastHeader = headerRow[headerRow.length - 1];
        if (lastHeader.toUpperCase() !== "TOTAL") {
            console.error(
                `El encabezado de la hoja "${targetSheet}" debe finalizar con "Total".`
            );
            return null;
        }

        let rows = rawData.slice(1);

        if (
            rows.length > 0 &&
            typeof rows[rows.length - 1][0] === "string" &&
            rows[rows.length - 1][0].trim().toUpperCase() === "TOTAL"
        ) {
            rows = rows.slice(0, rows.length - 1);
        }

        const items = rows.map(row => {
            const obj: any = {};
            headerRow.forEach((colName, index) => {
                obj[colName] = row[index];
            });
            return obj;
        });
        return { headers: headerRow, items: items };
    } catch (error) {
        console.error("Error al procesar el archivo Daily Sales:", error);
        return null;
    }
}
